<div>
  <ng-container *ngIf="withMainHeadline" class="mx-auto pt-[22px] px-[1.25rem] h-[calc(100%-100px)]">
    <nx-pageTitle-box class="mb-3" [label]="'Developer'" [icon]="'icon-api'" [iconToolTip]="'Developer'"
    [bcRootLvlLabel]="'Einstellungen'"
    [bcRootLvlPath]="'settings'">
    </nx-pageTitle-box>
    <ng-container *ngTemplateOutlet="table"></ng-container>
  </ng-container>

  <ng-container *ngIf="!withMainHeadline">
    <ng-container *ngTemplateOutlet="table"></ng-container>
  </ng-container>
  <ng-template #table>
    <div class="body">
      <p-tabView [(activeIndex)]="activeIndex" [scrollable]="true">
        <p-tabPanel header="API">
          <div class="mt-[1.25rem]">
            <app-api-keys/>
          </div>
        </p-tabPanel>
        <p-tabPanel header="Logs">
          <div class="mt-[1.25rem]">
            <app-http-logs class="full"/>
          </div>
        </p-tabPanel>
        <p-tabPanel header="Ereignisse">
          <div class="mt-[1.25rem]">
            <app-events class="full"/>
          </div>
        </p-tabPanel>
    </p-tabView>
    </div>
  </ng-template>
</div>
